export default {"src":"/_next/static/media/banerarowgif.cc3d435c.gif","height":120,"width":120,"blurWidth":0,"blurHeight":0};